import type { EngageLaunchPreview } from '@/store/features/engage.feature';
import type { SkillDto } from '@/types/gtm-agents';

/** The API's bound on the team's skills a Clu step links. */
export const MAX_WRITING_SKILLS = 3;

/**
 * The skills a Clu step may link: the org's live procedure skills from its
 * library (not one agent's own, not a draft).
 */
export function writingSkillChoices(skills: readonly SkillDto[]): SkillDto[] {
  return skills.filter(
    (skill) =>
      skill.kind === 'procedure' &&
      !skill.agentId &&
      (skill.status == null || skill.status === 'live')
  );
}

/**
 * The switch shows the price even with research off. Older dry runs fall
 * back to the charged per lead or per run value. Null when none is priced.
 */
export function researchPrice(
  clu: EngageLaunchPreview['clu'] | undefined
): number | null {
  if (clu?.research_price_per_lead != null) return clu.research_price_per_lead;
  const price =
    clu?.research_credits_per_lead || clu?.research_credits_per_run || 0;
  return price > 0 ? price : null;
}
